export const lang = {
    "message": {
        "msg_shop_close_on_date": "ただ今 で予約ができません。",
        "msg_shop_is_not_configured": "ただいま「{0}」では予約を受け付けておりません。",
        "msg_shop_is_not_configured1": "大変お手数ですが、詳しくは店舗にお問合せください。「{0}」",
        "msg_shop_online_booking_disabled": "この店舗は現在予約を受け取ることができません。",
    
        "msg_shop_is_not_existed": "予約可能店舗が存在していません。",
    
        "msg_required":"未入力です。",
        "msg_required_name": "お名前は必須です。",
        "msg_required_fullname": "ふりがなは必須です。",
        "msg_required_phone": "電話番号は必須です。",
        "msg_required_birthdate": "誕生日は必須です",
        "msg_invalid_birthdate": "正しい出生日を入力してください。",
        "msg_required_phone_or_email": "メールアドレスまた電話番号を入力してください。",
        "msg_invalid_email": "有効なメールアドレスを入力してください。",
        "msg_notmatch_email": "一致しません。",
        "msg_reservation_success": "予約内容を送信しました",
        "msg_update_appointment_success": "この予約はキャンセルできません。",
        "msg_reservation_error": "受け付けできませんでした。もう一度操作してください。",
        "msg_reservation_success_approved": "ご予約ありがとうございました。",
        "msg_reservation_success_approved2": "ご来店をお待ちしております。",
    
        "msg_reservation_success_unapproved": "ご利用ありがとうございます。ご予約を承り次第、折り返しの確認メールを送信させて戴きます。もう少々お待ちください。",
        "msg_booking_time_invalid": "選択した時間は空いていません。他の時間帯を選択して下さい",
        "msg_error": "エラー",
        "msg_appointment_deleted_success": "予約は削除されました。",
        "msg_appointment_confirm_deleted": "この予約をキャンセルしてもよろしいでしょうか？",
        "msg_invalid_booker_information": "お客様情報を入力してください",
        "msg_unknown_shop_id": "店舗ID:{0}存在しないです",
        "msg_invalid_username_password": "ユーザ名またはパスワードが間違いです。",
        "msg_appointment_view_only": "この予約の内容は変更できません",
        "msg_appointment_cannot_canceled":"この予約はキャンセルできません。",
        "msg_signout_confirm":"ログアウトしますか？",
        "msg_invalid_customer_name":"[%1]は名前として入力出来ません。",
        "msg_invalid_maxlength_phoneNumber":"電話番号は長すぎです。",
        "msg_invalid_maxlength_bookerName":"お名前は長すぎです。",
        "msg_invalid_maxlength_email":"メールアドレスは長すぎです。",
        "msg_invalid_maxlength_notes":"メモは長すぎです。",
        "msg_invalid_phoneNumber":"電話番号が間違っています。",
        "msg_invalid_furigana_name":"ふりがなは使用不可な文字が含まれています。",
        "msg_invalid_phoneNumber_fukada":"電話番号は使用不可な文字が含まれています。",
        "msg_error_not_defined": "出来ませんでした。もう一度操作してください。",
        "msg_invalid_type_time_select": "お電話受け取りが可能な時間帯です。",
        "msg_invalid_adv_select": "お申込みのきっかけになった広告はどれですかです。",
        "msg_invalid_adv_friend_select":"紹介者名は必須です。",
        "msg_invalid_age_select": "ご年齢です。",
        "msg_invalid_list_shop": "ご来店店舗は必須です。",
        "msg_invalid_request_item": "ご希望のアイテムは 必須です",
        "msg_invalid_list_order": "ご選択は必須です。",
        "msg_invalid_shop_close_res": "ご指定の日時と人数ではご予約できません。条件を変更して再度検索してください。"
    },
    "label": {
        "step_nav_product": "メニュー<br/>を選択する",
        "step_nav_employee": "スタッフ<br/>を指名する",
        "step_nav_timeline": "日時を<br/>指定する",
        "step_nav_confirmation": "内容確認/<br/>予約完了",
        "select_menu" : "メニューを選択してください",
        "please_select_staff": "スタッフを指名してください",
        "please_select_timeline": "予約日時を指定してください",
        "choose_a_staff" : "スタッフを選択してください",
        "choose_a_time": "日時を選択してください",
        "next": "次へ",
        "leave" : "変更する",
        "reservation":"予約する",
        "update_appt": "保存",
        "confirm_your_information": "あなたの情報を確認する",
        
        "form_header_info_appt": "ご予約内容",
        "form_header_info_booker": "お客様情報を入力してください",
        "menu": "メニュー",
        "staff": "スタッフ",
        "date_time" : "日付時刻",
        "name": "お名前",
        "full_name": "ふりがな",
        "phone_number": "電話番号",
        "email" : "Eメール",
        "sex" : "性別",            
        "age" : "年齢",
        "requestDate": "連絡希望日",
        "requestTime": "連絡希望時間",
        "sbsAge": "ご年齢",
        "message": "ご要望",
        "minute": "分",
        "confirm" : "予約内容を確認する",
        "confirm_yurikago": "確認画面へ進む",
        "required": "必須",
        "yen": "¥",
        "back": "戻る",
        "message_store_default": "店舗からのメッセージ:",
        "time_not_available": "選択した時間は空いていません。他の時間帯を選択して下さい",            
        "message_book_successfull": "ご予約ありがとうございました。<br /> ご来店をお待ちしております。",
        "message_book_successfull_restaurant": "仮予約ありがとうございました。<br />お店から最終確認のメール/電話を差し上げます。<br />いましばらくお待ちください。",
        "message_update_successfull": "変更が完了しました。<br /> ご来店をお待ちしております。",
        "message_book_fail": "受け付けできませんでした。<br />もう一度操作してください。",
        "message_shop_dayoff": "今日、私たちの店は動作しません",
        "message_no_product": "私はサービスしていない",
        "label_prev_calendar":"前の一週間",
        "label_next_calendar":"次の一週間",
        "lable_btn_remove_product": "キャンセル",
        "header_popup_staff": "スタッフ詳細",
        "header_popup_menu": "メニュー詳細",
        "label_male": "男性",
        "label_female": "女性",
        "label_time_accept": "お電話受け取りが可能な時間帯",
        "label_adv_select": "お申込みのきっかけになった広告はどれですか？",
        "label_note_sbs": "お問い合わせ内容・ご質問等 <br/>※ご自由にお書きください。",
        "label_note_yurikago": "備考欄",
        "label_list_shops": "店舗",
        "label_list_requests": "ご希望のアイテム<br/>( 複数選択可 )",
        "label_list_orders": "当店でオーダーされたこと はありますか？",
        "label_list_size": "上記で<br/>「ない」をご選択された方のみ<br/>ご入力ください",
        "select_product_res": "コース詳細・予約",
        "select_product_takeout":"商品詳細・予約",
        "label_yen": "円" ,
        "no_include_tax": "税抜",
        "label_duration_res": "時間",
        "label_price_res": "価格",
        "label_desc_res": "コース詳細",
        "label_desc_takeout": "商品詳細",
        "label_form_time_takeout": "テイクアウト受取希望時間",
        "label_form_time_res": "予約希望日時(お店から最終確認のメール/電話をもって予約確定となりますのでご注意ください）",
        "label_timeline_res": "予約日",
        "label_fromtime_res": "予約時間",
        "label_size_res": "予約人数",
        "label_size_takeout": "注文数",
        "label_booker_res": "お客様情報",
        "label_name_booker_res": "予約名"
        
    },
    "txt": {
        "label_header_shopname": "へのご予約",
        "header_note": "以下のフォームにお客様情報を入力し、メニューと時間を選択してください。",
        "header_note_timeline": "下記の中からお好きなメニューをお選びください。",
        "header_note_confirm": "お客様情報、ご予約内容をご確認ください。",
        "label_header_info": "お客様情報の入力",
        "label_header_menu": "メニュー・時間の選択",
        "label_header_menu_yuri": "メニューを選択",
        "label_header_timeline_yuri": "時間の選択",
        "label_header_subscribe": "メルマガ配信登録",
        "label_header_requestTime": "P・Aからの連絡希望日時（電話で予約確認をします）",
        "label_required": "※必須",
        "customer_name": "お名前",
        "customer_name_placeholder": "姓　名",
        "full_name": "ふりがな",
        "full_name_placeholder": "せい　めい",
        "phone_number": "電話番号/携帯番号",
        "phone_number_yuri": "電話番号",
        "email": "メールアドレス",
        "birthDate": "誕生日",
        "requestDate": "連絡希望日",
        "sex" : "性別",            
        "age" : "年齢",
        "requestTime": "連絡希望時間",
        "advSelect": "参照サイト",
        "advFriend": "紹介者名", 
        "list_request_item": "ご希望のアイテム",       
        "list_order": "当店でオーダーされたことはありますか？",
        "label_note": "備考",
        "label_height": "身　長",
        "label_width": "ウェスト",
        "label_weight": "体　重",
        "label_header_menu_selected": "選択中のメニュー",
        "label_add_more_product": "＋メニューを追加する",
        "select_product_placeholder": "選択してください",
        "label_select_product": "メニュー",
        "label_select_timeline": "予約希望日時",
        "msg_scroll_to_phone": "この教室の電話番号はこちら",
        "msg_note_select_timeline": "※「メニュー」を先にお選びください。",
        "notes_placeholder": "メッセージ",
        "msg_subscribe": "キャンペーンや割引など、ヴァカンスからのお得な情報を配信します。",                              
        "msg_subscribe_fukada": "キャンペーンや割引など、プロポーション・アカデミーからのお得な情報を配信します。",                              
        "subscribe_yes": "お得な情報を受け取る",
        "subscribe_no": "お得な情報を受け取らない",
        "button_subscribe": "予約内容を確認する",
        "support_by_phone": "お電話での相談・お申し込み",
        "support_by_phone_yuri": "お電話での相談・お申し込み",
        "title_popup": "お知らせ",
        "number_phone_on_mb": "へ電話をかける",
        "msg_no_product_timeline": " 先に予約メニューを選択してください",
        "label_product_sbs": "ご希望コース"
    }
}